import axios from "axios";
import { adminMainUrl } from "../../../Config";



//ff -> air -> export -> get query info by quotation
export const getAllNotifications = (customerToken) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CUSTOMER_ALL_NOTIFICATIONS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': customerToken,
            }
        };

        const apiUrl = `${adminMainUrl}/api/customer/get-all-notifications`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CUSTOMER_ALL_NOTIFICATIONS_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAllNotifications function (redux):", err);
                dispatch({
                    type: "FIND_CUSTOMER_ALL_NOTIFICATIONS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAllNotifications function:", error);
            dispatch({
                type: "FIND_CUSTOMER_ALL_NOTIFICATIONS_FAILURE",
                payload: error,
            });
        }
    };
};

